export class IMConstants {
  public static readonly MAX_LENGTH_CONFIGURABLE_VARIABLES = 256;

  public static readonly REGEX_NO_SPECIAL_CHARACTERS = /^[\p{L}0-9()\[\].\-][\s\p{L}0-9()\[\].\-]*$/u;

  public static readonly MIN_LENGTH_RULE_SET_NAME = 3;
  public static readonly MAX_LENGTH_RULE_SET_NAME = 32;
  public static readonly MAX_LENGTH_RULE_SET_DESCRIPTION = 256;

  public static readonly MIN_LENGTH_CUSTOM_RULE_NAME = 3;
  public static readonly MAX_LENGTH_CUSTOM_RULE_NAME = 64;
  public static readonly MAX_LENGTH_CUSTOM_RULE_DESCRIPTION = 256;

  public static readonly INTEGRITY_MONITOR_RULE_FILE_MAX_ALLOWED_KEYS = 32;
  public static readonly INTEGRITY_MONITOR_RULE_FILE_MAX_LENGTH_KEY = 256;

  public static readonly INTEGRITY_MONITOR_RULE_DIRECTORY_MAX_ALLOWED_PATHS = 32;
  public static readonly INTEGRITY_MONITOR_RULE_DIRECTORY_MAX_LENGTH_PATH = 256;

  public static readonly INTEGRITY_MONITOR_RULE_REGISTRYKEY_MAX_ALLOWED_KEYS = 32;
  public static readonly INTEGRITY_MONITOR_RULE_REGISTRYKEY_MAX_LENGTH_KEY = 256;

  public static readonly INTEGRITY_MONITOR_RULE_REGISTRYVALUE_MAX_ALLOWED_VALUES = 32;
  public static readonly INTEGRITY_MONITOR_RULE_REGISTRYVALUE_MAX_LENGTH_VALUE = 256;

  public static readonly NUM_DISPLAYED_RULE_SETS_ON_DELETE = 5;
  public static readonly NUM_DISPLAYED_POLICIES_ON_DELETE = 2;

  public static readonly URL_ATTACK_MITRE_TECHNIQUES = 'https://attack.mitre.org/techniques';
}
